// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__2tiOR","detailsBorder":"styles_detailsBorder__2FzEA"};